module.exports = __webpack_public_path__ + "static/img/RS.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/szafa/RS.png
// module id = PcuL
// module chunks = 0